<template>
  <v-dialog
    :model-value="modelValue"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="mt-2">
        <v-icon
          color="pink"
          size="24"
          class="mr-1"
        >
          mdi-alert-circle-outline
        </v-icon>
        AI作成が疑われる表現を検出
      </v-card-title>
      <v-card-text>
        回答文に「AI作成が疑われる表現」が含まれています。<br>
        本当に送信してもよろしいですか？
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="pink"
          variant="flat"
          @click="submitAndClose()"
        >
          <v-icon
            color="#fff"
            size="18"
          >
            mdi-alert-circle-outline
          </v-icon>
          そのまま送信する
        </v-btn>
        <v-btn
          variant="outlined"
          @click="close()"
        >
          修正する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SIDEBAR_TAB_IDS } from "@/vue/features/anytime-consultation-sidebar/model/sidebarTabIds";

export default {
  name: "StaticCheckConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue", "submit", "selectSidebarTab"],
  methods: {
    submitAndClose() {
      this.$emit("update:modelValue", false);
      this.$emit("submit");
    },
    close() {
      this.$emit("selectSidebarTab", SIDEBAR_TAB_IDS.AI_CORRECTION);
      this.$emit("update:modelValue", false);
    },
  },
};
</script>
